import React from 'react';
import { FeatureContainer, FeatureButton } from './WelcomeElements';

const Feature = () => {
  return (
    <FeatureContainer>
      <h1>Welcome to CryptoBearsClub</h1>
      <FeatureButton></FeatureButton>
      <p>CryptoBearsClub is a collection of 1,000 unique bear NFTs available on the Polygon blockchain.</p>
      <p>Each bear is completely unique, created using over 36 individual features.</p>
    </FeatureContainer>
  );
};

export default Feature;
